"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormItemTemplate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FormMode_1 = require("../FormMode");
const FormItemTemplateView_1 = require("./FormItemTemplateView");
const FormItemTemplateEdit_1 = require("./FormItemTemplateEdit");
const formik_1 = require("formik");
const FormItemTemplate = ({ renderEdit, validate, actionMode, ...props }) => {
    const { label, mode, value, name, required, viewValue } = props;
    const actualActionMode = actionMode ?? 'edit';
    const [field, meta] = (0, formik_1.useField)({
        name: name,
        validate: (value) => {
            if (required && (value === undefined || value === null || value === ""))
                return "Povinná položka!";
            if (validate)
                return validate(value);
            return undefined;
        },
    });
    return ((0, jsx_runtime_1.jsx)("div", { className: "w-100 pb-2", children: mode === FormMode_1.FormMode.VIEW ? ((0, jsx_runtime_1.jsx)(FormItemTemplateView_1.FormItemTemplateView, { ...props, actionMode: actualActionMode, label: label, content: viewValue ?? value, unit: props.unit })) : ((0, jsx_runtime_1.jsx)(FormItemTemplateEdit_1.FormItemTemplateEdit, { ...props, actionMode: actualActionMode, children: renderEdit, unit: props.unit })) }));
};
exports.FormItemTemplate = FormItemTemplate;
